import { Subscription } from 'rxjs';

abstract class LogLevel {
  public static readonly Empty: string = '<Log Level>';
  public static readonly Trace: string = 'Trace';
  public static readonly Debug: string = 'Debug';
  public static readonly Info: string = 'Info';
  public static readonly Warn: string = 'Warn';
  public static readonly Error: string = 'Error';
  public static readonly Silent: string = 'Silent';
}

abstract class Observables {
  public static readonly Closed: keyof Subscription = 'closed';
}

abstract class ProductShortName {
  public static readonly OITE: string = 'OITE';
  public static readonly ROCK: string = 'ROCK';
}

abstract class ApiUrl {
  public static readonly GetUserRole = 'api/enrollment/getRole';
  public static readonly SsoLogin = '/api/Authentication/login/?redirectPath=/login';
  public static readonly GetOverViewModel = 'api/enrollment/getoverviewmodel';
  public static readonly GetActiveProducts = 'api/enrollment/getActiveProducts';
  public static readonly GetRosterModel = 'api/enrollment/getRosterModel';
  public static readonly SaveSeat = 'api/enrollment/saveSeat';
  public static readonly SaveSeats = 'api/enrollment/saveSeats';
  public static readonly RemoveSeat = 'api/enrollment/removeSeat';
  public static readonly RemoveSeats = 'api/enrollment/removeSeats';
  public static readonly GetInstitutionInformation = 'api/enrollment/getInstitutionInformation';
  public static readonly SearchResident = 'api/enrollment/searchResident';
  public static readonly SaveResident = 'api/enrollment/saveResident';
  public static readonly GetProductInstance = 'api/enrollment/getproductinstance';
  public static readonly RemoveResident = 'api/enrollment/removeResident';
  public static readonly GetResidentModel = 'api/enrollment/getResidentModel';
  public static readonly GetCurrentDate = 'api/enrollment/getCurrentDate';
  public static readonly SetCurrentDate = 'api/enrollment/setCurrentDate';
  public static readonly ClearCurrentDate = 'api/enrollment/clearCurrentDate';
  public static readonly NotifyEnrollment = 'api/enrollment/notifyOfEnrollment';
  public static readonly GetOrderSummaryModel = 'api/enrollment/getOrderSummaryModel';
  public static readonly GetTransitionSubspecialties = 'api/enrollment/GetTransitionSubspecialties';
  public static readonly GetTransitionModel = 'api/enrollment/getTransitionModel';
  public static readonly saveTransition = 'api/enrollment/saveTransition';
  public static readonly GetFaculty = 'api/enrollment/getFaculty';
  public static readonly SaveFaculty = 'api/enrollment/saveFaculty';
  public static readonly RemoveFaculty = 'api/enrollment/removeFaculty';
  public static readonly SearchFaculty = 'api/enrollment/searchFaculty';
  public static readonly IsAuthenticated = '/api/authentication/isuserauthenticated';
}

abstract class ApiParams {
  public static readonly RedirectPath: string = 'redirectPath';
  public static readonly InstitutionId: string = 'institutionid';
  public static readonly FirstName: string = 'firstName';
  public static readonly LastName: string = 'lastName';
  public static readonly PrimaryEmail: string = 'primaryEmail';
  public static readonly AdditionalEmail: string = 'additionalEmail';
  public static readonly NPI: string = 'npi';
  public static readonly DateOfBirth: string = 'dateOfBirth';
  public static readonly BusinessPhone: string = 'businessPhone';
  public static readonly HomePhone: string = 'homePhone';
  public static readonly City: string = 'city';
  public static readonly StateProvince: string = 'stateProv';
  public static readonly ProductId: string = 'productid';
  public static readonly ResidentId: string = 'residentId';
  public static readonly ResidentName: string = 'residentname';
  public static readonly Mcid: string = 'mcid';
  public static readonly Resident: string = 'resident';
  public static readonly MaxLimit: string = 'maxLimit';
  public static readonly ContactWebRoleId: string = 'fcwrID';

  public static readonly Id: string = 'id';
  public static readonly Date: string = 'date';
}

abstract class DateFilterTypes {
  public static readonly Empty: string = '<Date Filter>';
  public static readonly None: string = 'None';
  public static readonly Day: string = 'Today';
  public static readonly Week: string = 'Last 7 Days';
  public static readonly Month: string = 'Last 30 Days';
  public static readonly BiMonth: string = 'Last 60 Days';
  public static readonly Quarter: string = 'Last 90 Days';
  public static readonly SemiAnnual: string = 'Last 6 Months';
  public static readonly Annual: string = 'Last Year';
}

abstract class Cookies {
  public static readonly Auth: string = '.AspNetCore.Cookies';
  public static readonly SsoAuthStatus: string = 'SsoAuthStatus';
  public static readonly LoggedInCookie = '255890d1-f8aa-4ac3-8e78-097fd9bcd3cf';
}

export const Constants = Object.freeze({
  ProductShortName,
  Observables,
  ApiUrl,
  DateFilterTypes,
  Cookies,
  LogLevel,
  ApiParams,
});
